<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" version="1.1" id="svg882" width="682.66669" height="682.66669" viewBox="0 0 682.66669 682.66669">
  <defs id="defs886">
    <clipPath clipPathUnits="userSpaceOnUse" id="clipPath920">
      <path d="M 0,512 H 512 V 0 H 0 Z" id="path918"/>
    </clipPath>
    <clipPath clipPathUnits="userSpaceOnUse" id="clipPath934">
      <path d="M 0,512 H 512 V 0 H 0 Z" id="path932"/>
    </clipPath>
    <clipPath clipPathUnits="userSpaceOnUse" id="clipPath958">
      <path d="M 0,512 H 512 V 0 H 0 Z" id="path956"/>
    </clipPath>
  </defs>
  <mask id="custom"><rect id="bg" x="0" y="0" width="100%" height="100%" fill="white"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"/></mask><g mask="url(#custom)"><g id="g888" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
    <g id="g890" transform="translate(362.0215,111.5215)">
      <path d="m 0,0 v 34.036 l -29.255,29.255 h -173.289 l -36.054,-22.507 h -23.09" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path892"/>
    </g>
    <g id="g894" transform="translate(455.3574,151.4014)">
      <path d="M 0,0 -8.302,16.799 -41.07,28.905 -102.021,2.84" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path896"/>
    </g>
    <g id="g898" transform="translate(123.4233,107.4961)">
      <path d="M 0,0 V 44.809" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path900"/>
    </g>
    <g id="g902" transform="translate(291.665,142.5967)">
      <path d="M 0,0 V -31.075" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path904"/>
    </g>
    <g id="g906" transform="translate(430.6094,82.2212)">
      <path d="M 0,0 -12.388,25.068" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path908"/>
    </g>
    <g id="g910" transform="translate(254.6978,151.4014)">
      <path d="M 0,0 H -88.531" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:15, 10, 15, 10, 350;stroke-dashoffset:0;stroke-opacity:1" id="path912"/>
    </g>
    <g id="g914">
      <g id="g916" clip-path="url(#clipPath920)">
        <path d="M 7.5,7.5 H 80.333 V 152.305 H 7.5 Z" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path922"/>
      </g>
    </g>
    <g id="g924" transform="translate(55,134.499)">
      <path d="M 0,0 V -81" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:15, 10, 15, 10, 350;stroke-dashoffset:0;stroke-opacity:1" id="path926"/>
    </g>
    <g id="g928">
      <g id="g930" clip-path="url(#clipPath934)">
        <g id="g936" transform="translate(100.3335,47.75)">
          <path d="M 0,0 H 23.09 L 168.553,-34.728 401.562,64.974 388.306,91.8 355.538,103.905 261.688,63.771 h -133.34" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path938"/>
        </g>
      </g>
    </g>
    <g id="g940" transform="translate(148.8579,233.6206)">
      <path d="M 0,0 H 93.604" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:15, 10, 15, 10, 15, 10;stroke-dashoffset:0;stroke-opacity:1" id="path942"/>
    </g>
    <g id="g944" transform="translate(146.4966,481.6587)">
      <path d="M 0,0 H 66.688" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:15, 10, 15, 10, 15, 10;stroke-dashoffset:0;stroke-opacity:1" id="path946"/>
    </g>
    <g id="g948" transform="translate(440.1592,384.8623)">
      <path d="M 0,0 H -109.706" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:15, 10, 15, 10, 350;stroke-dashoffset:0;stroke-opacity:1" id="path950"/>
    </g>
    <g id="g952">
      <g id="g954" clip-path="url(#clipPath958)">
        <g id="g960" transform="translate(463.6416,429.8623)">
          <path d="m 0,0 v 28.57 h -217.928 l -18.667,46.068 h -99.986 V 0" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path962"/>
        </g>
      </g>
    </g>
    <g id="g964" transform="translate(182.5269,458.4321)">
      <path d="M 0,0 H 63.187" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path966"/>
    </g>
    <path d="M 463.642,208.621 H 127.061 v 201.242 h 336.581 z" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path968"/>
    <g id="g970" transform="translate(389.8223,435.1812)">
      <path d="M 0,0 H 58.89" style="stroke:#000000;stroke-width:15;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path972"/>
    </g>
  </g></g>
</svg>
</template>
